import { Button } from "../../../../components/ui/common/button";

interface IngredientListPaginationProps {
  totalCount: number;
  pageNumber: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

/**
 * Tailwind pagination footer, copied from the Recipe Simulator list
 * (src/screens/recipe_simulator/newList/components/RecipeListPagination.tsx):
 * a count label on the left, Previous/Next `Button`s with a "Page X of Y"
 * label on the right — no page-number buttons/ellipsis, and it only renders
 * the pager controls when there's more than one page. Replaces the legacy
 * Semantic UI `PaginationView` (src/components/pagination/Pagination.tsx),
 * which also offered a page-size dropdown that this simpler pattern drops.
 */
const IngredientListPagination = ({
  totalCount,
  pageNumber,
  totalPages,
  onPageChange
}: IngredientListPaginationProps) => (
  <div className="tw-mt-3 tw-flex tw-items-center tw-justify-between">
    <p className="tw-text-xs tw-text-muted-foreground">
      {totalCount} ingredient{totalCount !== 1 ? "s" : ""} found
    </p>
    {totalPages > 1 ? (
      <div className="tw-flex tw-items-center tw-gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={pageNumber <= 1}
          onClick={() => onPageChange(pageNumber - 1)}
        >
          Previous
        </Button>
        <span className="tw-text-sm tw-text-muted-foreground">
          Page {pageNumber} of {totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          disabled={pageNumber >= totalPages}
          onClick={() => onPageChange(pageNumber + 1)}
        >
          Next
        </Button>
      </div>
    ) : null}
  </div>
);

export default IngredientListPagination;
